export default "__VITE_ASSET__CDJ4CGXq__"